(ns hai.library.prompts.edit
  "Prompts edit page components"
  (:require
   [hai-model.model :as model]
   [hai.sharing.components :as sharing.components]
   [hai.ui.components.form.core :as form]
   [hai.ui.components.form.input :as input]
   [hai.ui.components.new-design.button :as button]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.web-app.layout :as layout]
   [lambdaisland.ornament :as o]
   [malli.util :as mu]
   [reagent.core :as r]))

(o/defstyled update-button button/small
  button/dark
  [:&.disabled button/disabled]
  ([{:form/keys [on-submit valid?]}]
   [:<>
    {:class (when (not valid?) "disabled")
     :on-click on-submit}
    "Update"]))

(o/defstyled cancel-button button/small
  button/light
  ([]
   [:<>
    {:on-click (fn [_]
                 (>e [:routing/navigate [:ai-prompts/table]]))}
    "Cancel"]))

(o/defstyled delete-button button/small
  button/warning
  ([prompt]
   [:<>
    {:on-click (fn [_]
                 (>e [:assistant.prompt/delete
                      {:prompt prompt
                       :on-success [[:dispatch [:routing/navigate [:ai-prompts/table]]]]}]))}
    "Delete"]))

(o/defstyled form :div
  :flex :flex-col :gap-4
  [:.buttons :flex :gap-3]
  ([prompt]
   [form/component
    {:id ::form
     :schema (mu/select-keys model/Prompt [:ai-prompt/uuid :ai-prompt/title :ai-prompt/content])
     :initial-value prompt
     :on-submit (fn [prompt]
                  (>e [:assistant.prompt/update
                       {:prompt prompt
                        :on-success [[:dispatch [:entity/clear prompt]]
                                     [:dispatch [:routing/navigate [:ai-prompts/table]]]]}]))
     :render (fn [{:form/keys [on-submit valid-value]
                   {:ai-prompt/keys [title content]} :form/fields
                   :as form}]
               [:<>
                [form/label title
                 [input/field title]]
                [form/label content
                 [input/expanding-textarea content]]
                [:div.buttons
                 [update-button form]
                 [cancel-button]
                 [delete-button valid-value]]])}]))

(defn top-bar-menu
  [{:ai-prompt/keys [title]}]
  (let [route @(<s :routing/current-route-name)]
    [:<>
     [layout/breadcrumbs
      {:breadcrumbs [title (case route
                             :ai-prompts/edit "Edit"
                             :ai-prompts.edit/sharing "Sharing")]}]
     [layout/heading
      {:label (case route
                :ai-prompts/edit (str "Edit " title)
                :ai-prompts.edit/sharing (str "Share " title))}]
     [layout/top-bar-menu
      {:nav [{:title "Prompt"
              :route-name :ai-prompts/edit}
             {:title "Sharing"
              :route-name :ai-prompts.edit/sharing}]}]]))

(defn page
  [route]
  (when-let [prompt @(<s [:entity (-> @route :parameters :path)])]
    [layout/page
     [top-bar-menu prompt]
     [layout/content
      [form prompt]]]))

(defn sharing
  [route]
  (when-let [prompt @(<s [:entity (-> @route :parameters :path)])]
    [layout/page
     [top-bar-menu prompt]
     [layout/content
      [sharing.components/permissions-table prompt]]]))
